import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  APPROVE_UNBLOCK_VEHICLE_REQ,
  BLOCK_TRANSPORTER_VEHICLE,
  DOWNLOAD_DOCUMENT,
  GET_APPROVED_STAKEHOLDERS,
  GET_BLOCKED_TRANSPORTER_VEHICLE_LIST,
  GET_TRANSPORTER_VEHICLE_LIST,
  RAISE_UNBLOCK_TRANSPORTER_VEHICLE_REQ,
} from "../../common/URLs";
import {
  Container,
  Grid,
  Box,
  Card,
  IconButton,
  Tooltip,
  Stack,
  Typography,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  TextField,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { QuickSearchToolbar } from "../../payment/common/commonFunctions";
import { loaderService } from "../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { ViewIcon } from "../../common/icons";
import apiClient from "../../axios";
import { CATEGORY } from "../../common/constants";
import { Switch } from "antd";
import { openTextFieldMaxLength } from "../../common/commonValidations";
import { UPLOAD_DCUMENT, authKey } from "../../common/URLs";
import { allowedFileTypes, FILE_NAME_VALIDATION_ERROR } from "../../common/constants";
import { fileNameValidation } from "../../common/commonValidations";
import TrashIcon from '../../images/TrashIcon.png';
import { getLoadingButtonUtilityClass } from "@mui/lab";


function BlockVehicles() {
  const navigate = useNavigate();
  const [vehicleList, setVehicleList] = useState([]);
  const [category, setCategory] = useState("");
  const [urnList, setUrnList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [commentOpen, setCommentOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [commentValue, setCommentValue] = useState("");
  const [activeRow, setActiveRow] = useState(null);
  const [pendingChecked, setPendingChecked] = useState(false);

  const [blockedVehicleList, setBlockedVehicleList] = useState([]);
  const [documentsArr, setDocumentsArr] = useState([]);
const [selectedFile, setSelectedFile] = useState();
const [fileuploadError, setFileuploadError] = useState('');
const [documentUploadDetails, setDocumentUploadDetails] = useState();

  useEffect(() => {
    if (category && searchTerm) {
      getTransporterVehicleList();
    }
  }, [searchTerm, category]);

  useEffect(() => {
 if (selectedFile) {
   getDocumentUploadDetails();
 }
}, [selectedFile]);
useEffect(() => {
 if (documentUploadDetails) {
   let tempARR = documentsArr ? [...documentsArr] : [];
   documentUploadDetails?.blobResponse && tempARR.push(documentUploadDetails?.blobResponse);
   setDocumentsArr(tempARR);
 }
}, [documentUploadDetails]);

  const resetAll = () => {
    setCommentOpen(false);
    setConfirmOpen(false);
    setCommentValue("");
    setActiveRow(null);
    setPendingChecked(false);
  };

  //  update comment in grid row while typing in grid (optional but useful)
  const onRowCommentChange = (rowVehicleNumber, value) => {
    setVehicleList((prev) =>
      (prev || []).map((r) =>
        r.vehicleNumber === rowVehicleNumber
          ? { ...r, blockedVehicleComment: value }
          : r
      )
    );
  };

  // Toggle => ALWAYS ask comment (Yes/No both)
  const onToggleClick = (checked, row) => {
    if (!row) return;

    setActiveRow(row);
    setPendingChecked(checked);

    // Prefill comment dialog with existing comment (user can edit)
    setCommentValue(String(row.blockedVehicleComment || ""));
    setCommentOpen(true);
  };

  const onCommentNext = () => {
    const trimmed = String(commentValue || "").trim();
    if (!trimmed) {
      toast.error("Comment is mandatory.");
      return;
    }

    // reflect latest comment into the grid row immediately (so it shows in column)
    if (activeRow?.vehicleNumber) {
      setVehicleList((prev) =>
        (prev || []).map((r) =>
          r.vehicleNumber === activeRow.vehicleNumber
            ? { ...r, blockedVehicleComment: trimmed }
            : r
        )
      );
    }

    setCommentOpen(false);
    setConfirmOpen(true);
  };

  // const submitRequest = async () => {
  //   if (!activeRow) return;

  //   try {
  //     loaderService.showLoader();

  //     const trimmedComment = String(commentValue || "").trim();

  //     const payload = {
  //       vehicleBlockRequestList: [
  //         {
  //           stakeholderType: activeRow.stakeholderType,
  //           stakeholderUrn: activeRow.stakeholderUrn,
  //           vehicleNo: activeRow.vehicleNumber,
  //           vehicleBlockedComment: trimmedComment,
  //         },
  //       ],
  //     };

  //     //  Choose API based on toggle
  //     const apiUrl = pendingChecked
  //       ? BLOCK_TRANSPORTER_VEHICLE
  //       : APPROVE_UNBLOCK_VEHICLE_REQ;

  //     const response = await apiClient.post(apiUrl, payload, {
  //       headers: {
  //         Authorization: "Bearer " + getLocalStorageItem("id_token"),
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     const resData = response?.data;

  //     //  BUSINESS SUCCESS CHECK (adjust if backend differs)
  //     const isSuccess =
  //       resData?.success === true ||
  //       resData?.status === "SUCCESS" ||
  //       resData?.responseStatus === "OK";

  //     if (!isSuccess) {
  //       toast.error(resData?.message || "Operation failed.");
  //       loaderService.hideLoader();
  //       return;
  //     }

  //     //  Update grid ONLY after success
  //     setVehicleList((prev) =>
  //       (prev || []).map((r) =>
  //         r.vehicleNumber === activeRow.vehicleNumber
  //           ? {
  //             ...r,
  //             isVehicleBlocked: pendingChecked,
  //             blockedVehicleComment: trimmedComment,
  //           }
  //           : r
  //       )
  //     );

  //     toast.success(
  //       pendingChecked
  //         ? "Vehicle blocked successfully."
  //         : "Vehicle unblocked successfully."
  //     );

  //     loaderService.hideLoader();
  //     resetAll();
  //   } catch (error) {
  //     loaderService.hideLoader();
  //     console.error("BLOCK/UNBLOCK_API_ERROR", error);
  //     toast.error(error?.message || "Something went wrong.");
  //   }
  // };

  const uploadDocument = (e) => {

  const file = e.target.files[0];

  if (allowedFileTypes.indexOf(file.type) < 0) return;

  if (file.size >= 5000000) {

    setFileuploadError('The file should be less than 5MB');

    setSelectedFile(undefined);

  } else if (file.name.split('.').length > 2) {

    setFileuploadError("Double extension file detected");

    setSelectedFile(undefined);

  } else if (fileNameValidation(file.name)) {

    setFileuploadError(FILE_NAME_VALIDATION_ERROR);

    setSelectedFile(undefined);

  } else {

    setSelectedFile(file);

    setFileuploadError('');

  }

};

const getDocumentUploadDetails = () => {

  loaderService.showLoader();

  const formData = new FormData();

  formData.append("file", selectedFile);

  formData.append("fileName", selectedFile.name);

  formData.append("containerName", "pit");

  apiClient.post(UPLOAD_DCUMENT, formData, {

    headers: { AuthKey: authKey },

  })

  .then((response) => {

    setDocumentUploadDetails(response.data);

    loaderService.hideLoader();

  })

  .catch((error) => {

    console.log(error);

    loaderService.hideLoader();

  });

};

const onDeleteFile = (e, item) => {

  e.preventDefault();

  const rows = [...documentsArr];

  const index = rows.findIndex((doc) => doc === item);

  if (index !== -1) {

    rows.splice(index, 1);

    setDocumentsArr(rows);

  }

};
 

  const submitRequest = async () => {
    if (!activeRow) return;

    const trimmed = String(commentValue || "").trim();

    const blockVehicleDocumentList = (documentsArr || []).map((item) => ({
 bLockVehicleFileId: item?.blobFileName,
 bLockVehicleFileName: item?.fileName,
 containerName: "pit",
}));

    // comment mandatory for BOTH yes/no
    if (!trimmed) {
      toast.error("Reason/Comment is mandatory.");
      return;
    }

    // unblock needs vehicleBlockedRequestNumber
    if (!pendingChecked && !activeRow.vehicleBlockedRequestNumber) {
      toast.error("vehicleBlockedRequestNumber is missing for this row. Cannot unblock.");
      return;
    }

    try {
      loaderService.showLoader();

      let apiUrl = "";
      let payload = {};

      if (pendingChecked) {
        //  BLOCK payload (comment required)
        apiUrl = BLOCK_TRANSPORTER_VEHICLE;
        payload = {
          vehicleBlockRequestList: [
            {
              stakeholderType: activeRow.stakeholderType,
              stakeholderUrn: activeRow.stakeholderUrn,
              vehicleNo: activeRow.vehicleNumber,
              vehicleBlockedComment: trimmed,
              ...(blockVehicleDocumentList.length > 0 ? { blockVehicleDocumentList } : {}),
            },
          ],
        };
      } else {
        //  UNBLOCK payload (as per current swagger)
        apiUrl = RAISE_UNBLOCK_TRANSPORTER_VEHICLE_REQ;
        //   payload = {
        //     vehicleBlockedRequestNumber: activeRow.vehicleBlockedRequestNumber,
        //     stakeholderType: activeRow.stakeholderType,
        //     stakeholderUrn: activeRow.stakeholderUrn,
        //     vehicleNo: activeRow.vehicleNumber,

        //     // Provision kept for future (if swagger adds comment later)
        //     // vehicleBlockedComment: trimmed,
        //     // unblockComment: trimmed,
        //   };
        // }
        payload = {
          raiseRequestForVehicleUnblocks: [
            {
              vehicleBlockedRequestNumber: activeRow.vehicleBlockedRequestNumber,
              stakeholderType: activeRow.stakeholderType,
              stakeholderUrn: activeRow.stakeholderUrn,
              vehicleNo: activeRow.vehicleNumber,
              vehicleUnBlockedComment: trimmed,
            },
          ],
          roleName: getLocalStorageItem('role'),
        };
      }
      const response = await apiClient.post(apiUrl, payload, {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
          "Content-Type": "application/json",
        },
      });

      const resData = response?.data;

      const isSuccess =
        resData?.isSuccess === true ||
        resData?.status === "success" ||
        resData?.responseStatus === "OK";

      if (!isSuccess) {
        toast.error(resData?.message || "Operation failed.");
        loaderService.hideLoader();
        return;
      }
      //  Update UI ONLY after success
      setVehicleList((prev) =>
        (prev || []).map((r) =>
          r.vehicleNumber === activeRow.vehicleNumber
            ? {
              ...r,
              isVehicleBlocked: pendingChecked,
              blockedVehicleComment: trimmed, //  always keep comment in grid for both block/unblock
            }
            : r
        )
      );

      toast.success(pendingChecked ? "Vehicle blocked successfully." : "Vehicle unblocked successfully.");
      getTransporterVehicleList();
      loaderService.hideLoader();
      resetAll();
    } catch (error) {
      loaderService.hideLoader();
      console.error("BLOCK/UNBLOCK_API_ERROR", error);
      toast.error(error?.message || "Something went wrong.");
      setDocumentsArr([]);
setSelectedFile(undefined);
setFileuploadError('');
setDocumentUploadDetails(undefined);
    }
  };

  const columns = [
    { field: "stakeholderType", headerName: "Stakeholder Type", width: 130 },
    { field: "stakeholderUrn", headerName: "Stakeholder URN", width: 160 },
    { field: "vehicleNumber", headerName: "Vehicle Number", width: 160 },
    {
      field: "vehicleBlockedComment",
      headerName: "Blocked Vehicle Comment",
      width: 360,
      sortable: false,
      renderCell: (params) => {
        const row = params.row;

        const stopGridEvent = (e) => e.stopPropagation();

        return (
          <TextField
            variant="standard"
            fullWidth
            multiline
            value={row.blockedVehicleComment || ""}
            placeholder="Comment"
            inputProps={{ maxLength: openTextFieldMaxLength }}
            onKeyDown={stopGridEvent}
            onClick={stopGridEvent}
            onChange={(e) => onRowCommentChange(row.vehicleNumber, e.target.value)}
          />
        );
      },
    },
    { field: "vehicleBlockedRequestNumber", headerName: "Vehicle Blocked Request Number", width: 220 },
    {
 field: "vehicleBlockrequestDocumentList",
 headerName: "Documents",
 width: 250,
 sortable: false,
 renderCell: (params) => {
   const docs = params.row.vehicleBlockrequestDocumentList || [];
   if (!docs.length) return <Typography variant="body2" color="text.secondary">—</Typography>;
   return (
<Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, py: 0.5 }}>
       {docs.map((doc, idx) => (
<Typography
           key={idx}
           variant="body2"
           component="a"
           href="#"
           onClick={async (e) => {
             e.preventDefault();
             try {
               const response = await apiClient.post(
                 DOWNLOAD_DOCUMENT,
                 {
                   fileName: doc.vehicleBlockrequestFileId,
                   containerName: doc.containerName || "pit",
                 },
                 {
                   headers: { AuthKey: authKey },
                   responseType: "blob",
                 }
               );
               const url = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement("a");
               link.href = url;
               link.setAttribute("download", doc.vehicleBlockrequestFileName || doc.vehicleBlockrequestFileId);
               document.body.appendChild(link);
               link.click();
               link.remove();
               window.URL.revokeObjectURL(url);
             } catch (err) {
               toast.error("Document download failed.");
             }
           }}
           sx={{ color: "primary.main", cursor: "pointer", textDecoration: "underline" }}
>
           {doc.vehicleBlockrequestFileName || doc.vehicleBlockrequestFileId}
</Typography>
       ))}
</Box>
   );
 },
},
    {
      field: "isVehicleBlocked",
      headerName: "Blocked",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <Switch
            checked={Boolean(params?.row?.isVehicleBlocked)}
            checkedChildren="Yes"
            unCheckedChildren="No"
            onChange={(checked) => onToggleClick(checked, params?.row)}
          />
        );
      },
    }
  ];

  const handleChange = (e) => {
    setCategory(e.target.value);
    onCategoryChange(e.target.value);
  };

  const onCategoryChange = (category) => {
    loaderService.showLoader();
    apiClient
      .post(
        GET_APPROVED_STAKEHOLDERS,
        { type: category },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setUrnList(response.data.stakeHolders);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  const getTransporterVehicleList = () => {
    loaderService.showLoader();
    apiClient
      .post(
        GET_TRANSPORTER_VEHICLE_LIST,
        {
          stakeholderType: category,
          stakeholderUrn: searchTerm,
          roleName: getLocalStorageItem("role"),
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        }
      )
      .then((response) => {
        const list = (response.data.transporterVehicleStatusList || []).map((r) => ({
 ...r,
 blockedVehicleComment: r.blockedVehicleComment || "",
 vehicleBlockrequestDocumentList: r.vehicleBlockrequestDocumentList || [],
}));
        setVehicleList(list);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  return (
    <>
      <Container maxWidth="xxl">
        <Stack direction={{ xs: "column", sm: "row" }} mb={1} justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            Block Vehicle
          </Typography>
        </Stack>

        <Grid container spacing={3}>
          <Grid item xs={12} lg={4}>
            <FormControl sx={{ width: "100%", paddingRight: "3%" }}>
              <InputLabel id="selectstakeholder-label">{CATEGORY}</InputLabel>
              <Select label={CATEGORY} name="category" value={category || ""} onChange={(e) => handleChange(e)}>
                <MenuItem value="">
                  <em>{CATEGORY}</em>
                </MenuItem>
                <MenuItem value="HIT">HIT</MenuItem>
                <MenuItem value="Transporter">Transporter</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} lg={8}>
            <Autocomplete
              value={urnList.find((o) => o.urn === searchTerm) || null}
              getOptionLabel={(opt) => `${opt.urn} - ${opt.name}`}
              isOptionEqualToValue={(opt, val) => opt.urn === val.urn}
              onChange={(_, newValue) => {
                const urn = newValue?.urn ?? "";
                setSearchTerm(urn);
              }}
              options={urnList || []}
              renderInput={(params) => <TextField {...params} label="Search URN" variant="outlined" fullWidth />}
            />
          </Grid>

          <Grid item xs={12} lg={12}>
            <Card>
<Box style={{ height: 450, width: "100%" }}>
                <DataGrid
                  getRowHeight={() => "auto"}
                  rows={vehicleList || []}
                  columns={columns}
                  getRowId={(row) => row.vehicleNumber}
                  pageSize={10}
                  components={{ Toolbar: QuickSearchToolbar }}
                  disableRowSelectionOnClick
                />
                </Box>
 
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/*  Comment dialog (mandatory for both Yes/No) */}
      {/*  Comment dialog (mandatory for both Yes/No) */}
<Dialog open={commentOpen} onClose={resetAll} fullWidth maxWidth="sm">
<DialogTitle>

    {pendingChecked ? "Add comment to Block" : "Add comment to Unblock"}
</DialogTitle>
<DialogContent>
<TextField

      autoFocus

      fullWidth

      required

      label="Comment"

      value={commentValue}

      onChange={(e) => setCommentValue(e.target.value)}

      multiline

      minRows={3}

      inputProps={{ maxLength: openTextFieldMaxLength }}

      sx={{ mt: 1 }}

    />

    {/* ── Upload Document Section ── */}

    {pendingChecked && (
<Box sx={{ mt: 2 }}>
<Button

          variant="outlined"

          component="label"

          size="small"
>

          Upload Document
<input

            type="file"

            hidden

            accept={allowedFileTypes.join(",")}

            onChange={uploadDocument}

          />
</Button>

        {fileuploadError && (
<Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5 }}>

            {fileuploadError}
</Typography>

        )}

        {/* Uploaded files list */}

        {documentsArr && documentsArr.length > 0 && (
<Box sx={{ mt: 1 }}>

            {documentsArr.map((item, index) => (
<Box

                key={index}

                sx={{

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "space-between",

                  border: "1px solid #e0e0e0",

                  borderRadius: 1,

                  px: 1.5,

                  py: 0.5,

                  mt: 0.5,

                  backgroundColor: "#f9f9f9",

                }}
>
<Typography variant="body2" noWrap sx={{ maxWidth: 360 }}>

                  {item?.fileName || item?.blobFileName}
</Typography>
<IconButton

                  size="small"

                  onClick={(e) => onDeleteFile(e, item)}
>
<img src={TrashIcon} alt="delete" style={{ width: 16, height: 16 }} />
</IconButton>
</Box>

            ))}
</Box>

        )}
</Box>

    )}
</DialogContent>
<DialogActions>
<Button onClick={resetAll}>Cancel</Button>
<Button variant="contained" onClick={onCommentNext}>

      Next
</Button>
</DialogActions>
</Dialog>
 

      {/* Confirmation dialog */}
      <Dialog open={confirmOpen} onClose={resetAll} fullWidth maxWidth="xs">
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            {pendingChecked ? "Do you want to block this vehicle?" : "Do you want to unblock this vehicle?"}
          </Typography>
          <Typography variant="caption" sx={{ display: "block", mt: 1, wordBreak: "break-word" }}>
            Comment: {String(commentValue || "").trim()}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={resetAll}>Cancel</Button>
          <Button variant="contained" onClick={submitRequest}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

    </>

  );
}

export default BlockVehicles;